<template>
  <a-modal title="标记沟通结果" :footer="null" v-model="visible" :destroyOnClose="true">
    <a-form :form="form">
      <a-form-item label="沟通结果">
        <a-textarea
          :rows="6"
          placeholder="请填写沟通结果，如没有获取到职位原因是什么，已获取到职位，职位数量有多少"
          v-decorator="[
            'remark',
            { rules: [{ required: true, message: '请填写沟通结果' }] }
          ]"
        ></a-textarea>
      </a-form-item>
    </a-form>
    <a-divider></a-divider>
    <a-row type="flex" :gutter="10" justify="end">
      <a-col>
        <a-button @click="save('FAILED')" :loading="cancelLoading">未获取到{{title}}</a-button>
      </a-col>
      <a-col>
        <a-button type="primary" @click="save('SUCCESS')" :loading="sureLoading">已获取到{{title}}</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import Api from "@/api";
export default {
  name: "MarkModal",
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      record: {},
      type: "",
      visible: false,
      sureLoading: false,
      cancelLoading: false,
      title: ""
    };
  },
  methods: {
    save(confirm) {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          confirm === "FAILED"
            ? (this.cancelLoading = true)
            : (this.sureLoading = true);
          this.$emit("check", this.record, values.remark, confirm);
        }
      });
    },
    async show(record) {
      this.record = record;
      if ("remark" in record) {
        this.title = "简历";
        this.visible = true;
        await this.$nextTick();
        this.form.setFieldsValue({
          remark: this.record.remark || ""
        });
      } else {
        this.title = "职位";
        let { communication } = await Api.cash.getJobCommunication({
          job_clue_id: record.id
        });
        this.visible = true;
        await this.$nextTick();
        this.form.setFieldsValue({
          remark: communication.body
        });
      }
    },
    close() {
      this.distubeLoading();
      this.visible = false;
    },
    distubeLoading() {
      this.cancelLoading = false;
      this.sureLoading = false;
    }
  }
};
</script>

<style scoped lang="scss"></style>
